var map = {
	"./android/DeviceSetup": 1375,
	"./androidtv/DeviceSetup": 1376,
	"./arris/DeviceSetup": 1377,
	"./hisense/DeviceSetup": 1378,
	"./lg/DeviceSetup": 1379,
	"./nagra/DeviceSetup": 1381,
	"./netrange/DeviceSetup": 1382,
	"./opera/DeviceSetup": 1383,
	"./polaroid/DeviceSetup": 1384,
	"./ps4/DeviceSetup": 1385,
	"./samsung/DeviceSetup": 1386,
	"./seirobotics/DeviceSetup": 1387,
	"./sony/DeviceSetup": 1388,
	"./stbcoship/DeviceSetup": 1389,
	"./stbcoship9108/DeviceSetup": 1390,
	"./stbhuawei/DeviceSetup": 1391,
	"./stbkaon/DeviceSetup": 1392,
	"./tizen/DeviceSetup": 1393,
	"./web0s/DeviceSetup": 1394,
	"./workstation/DeviceSetup": 1396,
	"./workstationChafari/DeviceSetup": 1397,
	"./zeasn/DeviceSetup": 1398,
	"./zte/DeviceSetup": 1399
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1374
// module chunks = 0